import { Card, Grid, Paper, Typography, CardContent, Stack, TextField, ToggleButton, Button } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useCreatePersonMutation, useListPersonsQuery } from '../../features/model/personSlice';
import { RecurringBonusCard, AddRecurringBonusCard } from './RecurringBonusCard';

const AddNewPersonCard = ({onAddNew = null}) => {
  return (
      <Paper><Card key="add_new" sx={{width: 256, minHeight: 140, paddingTop: 2}}>
          <center><Typography variant="subtitle1">Add new</Typography></center>
          <center><TextField
              sx={{marginTop: 2}}
              placeholder='Type and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onAddNew(e.target.value);
                  }
              }}
          /></center>
      </Card></Paper>);
}

const PersonGridCard = ({object}) => {
  const makeLinkToObject = (object) => {
    return `/persons/${object.id}`
  }

  return <Grid item component={RouterLink} to={makeLinkToObject(object)}>
    <Paper elevation={1}>
      <Card sx={{width: 256, minHeight: 140, paddingTop: 4}}>
        <CardContent>
          <Stack direction="column">
          <Typography variant="h3" textAlign="center">{object.full_name}</Typography>
          <Typography variant="subtitle1" textAlign="center">{object.name}</Typography>
          <Typography variant="caption" textAlign="center" color="red">{object.locked ? "locked": ""}</Typography>
          </Stack>
        </CardContent>
      </Card>
    </Paper>
  </Grid>
}

const PersonsBrowser = () => {
    const {data, error, isLoading } = useListPersonsQuery();
    const [showInactive, setShowInactive] = useState(false);
    const [createPerson, {isLoadingUpdate: isUpdating }] = useCreatePersonMutation();

    function createNew(name) {
      createPerson({
        name: name,
        active: true,
        password: "",
        email: "",
        department: ""
      });
    }

    if (isLoading || isUpdating) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const sortedObjects = data.objects.slice().filter((o) => !o.name.startsWith("dept:")).sort((a, b) => a.name.localeCompare(b.name));
    const inactives = sortedObjects.filter((o) => !o.active);
    const actives = sortedObjects.filter((o) => o.active);

    return <Stack direction="column" sx={{marginTop: 2, marginBottom: 4}} spacing={1}>
      <Typography variant="h1">People</Typography>
      <Grid container spacing={2}>
        {
            actives.map((object, i) => <PersonGridCard object={object} key={object.id} />)
        }
        <Grid item key="new"><AddNewPersonCard onAddNew={createNew}/></Grid>
      </Grid>
      <Button onClick={() => {setShowInactive(!showInactive)}} sx={{marginTop: 4}}>{showInactive ? "Hide" : "Show"} {inactives.length} inactive accounts</Button>
      {showInactive &&
      <Grid container spacing={2}>
        {
            inactives.map((object, i) => <PersonGridCard object={object} key={object.id} />)
        }
        <Grid item key="new"><AddNewPersonCard onAddNew={createNew}/></Grid>
      </Grid>
      }
      </Stack>
}

export default PersonsBrowser;